import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import { IEmptyElementFactoryParameters } from '#/DefaultViewExtensionInterfaces';

export default class EmptyElementFactory extends ControlFactory {

    private jQueryControl: JQuery;

    public constructor(private params: IEmptyElementFactoryParameters) {
        super(params);

        this.labelPosition = this.paramOrDefault(this.params.labelPosition, 'None');
        this.isVisible(params.visible === true);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        
        this.jQueryControl = $();

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('EmptyElement', EmptyElementFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');